import getCalendarPickerStore from '../selectors/getCalendarPickerStore';
import type CalendarPickerScenarioId from '../store/schema/CalendarPickerScenarioId';
import { mutatorAction } from 'satcheljs';

export const setContextMenuViewState = mutatorAction(
    'setContextMenuViewState',
    function setContextMenuViewState(
        scenarioId: CalendarPickerScenarioId,
        itemId: string,
        anchorElement: Element
    ) {
        if (itemId) {
            getCalendarPickerStore(scenarioId).contextMenu = {
                itemId,
                anchorElement,
            };
        }
    }
);

export const hideContextMenu = mutatorAction(
    'hideContextMenu',
    function hideContextMenu(scenarioId: CalendarPickerScenarioId) {
        getCalendarPickerStore(scenarioId).contextMenu = null;
    }
);
